import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import shortenNumber from '../../../../utils/shortenNumber';
import Timestamp from '../../../../Timestamp';
import s from './StatBlock.scss';
export var StatBlock = function (_a) {
    var views = _a.views, today = _a.today, publishedTime = _a.publishedTime, isMature = _a.isMature, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['view-stats'], className) },
        React.createElement("div", null,
            React.createElement("span", { className: s['views'] },
                shortenNumber(views),
                " ",
                t('deviation.details.views')),
            React.createElement("span", { className: s['view-separator'] }, "|"),
            React.createElement("span", { className: s['today'] },
                shortenNumber(today),
                " ",
                t('deviation.details.today'))),
        publishedTime && (React.createElement("div", { className: s['date'] },
            React.createElement(Timestamp, { timestamp: publishedTime }))),
        isMature && (React.createElement("div", { className: s['mature-tag'] }, t('deviation.details.matureContent')))));
};
StatBlock.displayName = 'StatBlock';
export default StatBlock;
//# sourceMappingURL=StatBlock.js.map